export default __webpack_public_path__ + "static/media/about-team-member-2.7e5ad18a.jpg";